import ConfigurePaymentDialog from './ConfigurePaymentDialog'
export * from './ConfigurePaymentDialog'
export default ConfigurePaymentDialog
